import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { Map } from 'immutable';
import { toIdString } from '../../utils/common';
import { getClassName, checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

const FORM_ID = 'filesetForm';

const BLANK_VALUES = new Map({
  id: 0,
  dataFilenamePattern: '',
  layoutFilename: '',
  recordLevelTypeId: 0,
});

export default class FilesetForm extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitFunction: PropTypes.func.isRequired,
    recordLevelTypes: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
    isNewFileset: PropTypes.bool.isRequired,
    pageChangeFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { submitFunction } = this.props;
    submitFunction(params);
  };

  renderSelect = ({ input, label, meta: { touched, error } }) => {
    const { recordLevelTypes } = this.props;

    return (
      <div className={getClassName(touched, error)}>
        <label htmlFor={toIdString(label)} className="form-control-label">
          {label} {touched && error && <span> | {error} </span>}
        </label>
        <div>
          <select {...input} id={toIdString(label)}>
            <option value="">&lt; Please Select &gt;</option>
            {recordLevelTypes.size > 0 ? recordLevelTypes.map(this.renderRecordLevelTypes) : null}
          </select>
        </div>
      </div>
    );
  };

  renderRecordLevelTypes = type => (
    <option key={type.id} value={type.id}>
      {type.description}
    </option>
  );

  render() {
    const { handleSubmit, invalid, submitting, isNewFileset, pageChangeFunction } = this.props;

    return (
      <Form id={FORM_ID} onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <Field
            name="dataFilenamePattern"
            type="text"
            component={InputField}
            label="Filename Pattern"
            placeholder="accounts*.csv"
            autoFocus
          />
          <Field name="recordLevelTypeId" component={this.renderSelect} label="Record Level Type" />
        </fieldset>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={checkButtonDisabled(invalid, submitting)}
        >
          {isNewFileset ? 'Create Fileset' : 'Update Fileset'}
        </button>&nbsp;
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => {
            pageChangeFunction(0, BLANK_VALUES);
          }}
        >
          Cancel
        </button>
      </Form>
    );
  }
}
